import type {
    CustomerLocationAssociatePayload,
    CustomerLocationUpdatePayload,
    ICustomerLocationAssociationRow,
    ILocationSelectItem,
} from "@/customTypings/customer/Customer";
import { authHeader, handleResponse } from "../../utils";

function associationsBase(siteId: string, customerId: string) {
    return `/api/sites/${encodeURIComponent(siteId)}/customers/${encodeURIComponent(customerId)}/location-associations`;
}

export const customerLocationAssociationsService = {
    listAvailableLocations,
    associateLocation,
    updateAssociation,
    setMainAssociation,
    unlinkAssociation,
};

function listAvailableLocations(siteId: string, customerId: string, q?: string) {
    const query = q?.trim() ? `?q=${encodeURIComponent(q.trim())}` : "";
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader(),
        credentials: "include",
    };
    return fetch(`${associationsBase(siteId, customerId)}/available-locations${query}`, requestOptions).then(
        handleResponse
    ) as Promise<ILocationSelectItem[]>;
}

function associateLocation(siteId: string, customerId: string, payload: CustomerLocationAssociatePayload) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
        body: JSON.stringify(payload),
    };
    return fetch(`${associationsBase(siteId, customerId)}/associate`, requestOptions).then(
        handleResponse
    ) as Promise<ICustomerLocationAssociationRow>;
}

function updateAssociation(siteId: string, customerId: string, payload: CustomerLocationUpdatePayload) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
        body: JSON.stringify(payload),
    };
    return fetch(`${associationsBase(siteId, customerId)}/update`, requestOptions).then(handleResponse);
}

function setMainAssociation(siteId: string, customerId: string, associationId: string) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
    };
    return fetch(
        `${associationsBase(siteId, customerId)}/set-main?id=${encodeURIComponent(associationId)}`,
        requestOptions
    ).then(handleResponse);
}

function unlinkAssociation(siteId: string, customerId: string, associationId: string) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
    };
    return fetch(
        `${associationsBase(siteId, customerId)}/unlink?id=${encodeURIComponent(associationId)}`,
        requestOptions
    ).then(handleResponse);
}
